import {ConfEnv} from "../../../../config/config";
import privateRequest from "../../../../Infra/http/private.request";

/**
 * Fetch all available lottery games from the new API endpoint
 * Returns games with their draws, figures, and other configuration
 */
export const getLotteryGamesService = () => {
  return privateRequest.get(`${ConfEnv.BASE_URL}/lottery/games`);
};
